const signOutLinks = document.querySelectorAll('a[href="/users/sign_out"]');
signOutLinks.forEach(link => {
  link.addEventListener('click', () => {
    localStorage.removeItem('dispatchOrderFilterValues')
  })
})